import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
import {  useParams } from "react-router-dom";
// import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const AddStockOperationModel = ({ show, handleClose }) => {
  // const [showCategory, setShowCategory] = useState(false);
  // const [showModel, setShowModel] = useState(false);
  // const [showEvents, setShowEvents] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  // const [cabranesList, setCabranesList] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
  let { id } = useParams();
      let season_id = localStorage.getItem("season_id");

  const [formData, setFormData] = useState({
    id:id,
    season_id: season_id,
    quantity: "",
    note: "",
    operation_type:''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setBackendErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };




  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/quality-stock-follow-ups/add-manual", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
           window.location.href = "/quality-stock-situations-viewby-consumable-location/"+id;
          }, 500);
        } else {
          setBackendErrors(response.data.error || {});
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  
  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header>
          <h4 className="modal-title">Add Stock Follow Up</h4>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            aria-hidden="true"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            {backendSuccess && (
              <div className="from-success mt-1">{backendSuccess}</div>
            )}

            <div className="form-group">
              <label>Quanity: </label>
              <input type='number'
                className="form-control form-white"
                placeholder="Enter Quanity"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
              />
              {backendErrors.quantity && (
                <small className="form-error mt-1">{backendErrors.quantity}</small>
              )}
            </div>
            <div className="form-group">
              <label>Operation Type: </label>
              <select name="operation_type"
                className="form-control form-white"
                placeholder="Enter Note"
             
                value={formData.operation_type}
                onChange={handleChange}
              >
                <option value=''>Select</option>
                <option value='IN'>IN</option>
                <option value='OUT'>OUT</option>
                </select>
              {backendErrors.operation_type && (
                <small className="form-error mt-1">{backendErrors.operation_type}</small>
              )}
            </div>
            <div className="form-group">
              <label>Note</label>
              <textarea
                className="form-control form-white"
                placeholder="Enter Note"
             
                name="note"
                value={formData.note}
                onChange={handleChange}
              ></textarea>
              {backendErrors.note && (
                <small className="form-error mt-1">{backendErrors.note}</small>
              )}
            </div>

            <div className="submit-section">
              <button
                type="submit"
                className="btn btn-primary save-category submit-btn"
                data-bs-dismiss="modal"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// Prop validation
AddStockOperationModel.propTypes = {
  show: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddStockOperationModel;
